module.exports = __webpack_public_path__ + "img/symbol_0.d7a7981d.png";